var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon300_delete"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_375_3664",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_375_3664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "delete",
    d: "M8.24617 19C7.84719 19 7.50642 18.8536 7.22386 18.5607C6.94129 18.2678 6.8 17.9146 6.8 17.5011V6.9772H6V5.73347H9.59999V5H14.4V5.73347H18V6.9772H17.2V17.5011C17.2 17.92 17.06 18.2745 16.78 18.5647C16.5 18.8549 16.1579 19 15.7538 19H8.24617ZM16 6.9772H7.99999V17.5011C7.99999 17.5755 8.02307 17.6367 8.06923 17.6845C8.11539 17.7324 8.17437 17.7563 8.24617 17.7563H15.7538C15.8154 17.7563 15.8718 17.7297 15.9231 17.6766C15.9744 17.6234 16 17.5649 16 17.5011V6.9772ZM9.92309 16.098H11.1231V8.63552H9.92309V16.098ZM12.8769 16.098H14.0769V8.63552H12.8769V16.098Z",
    fill: "#888888"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.4df6c06241dd8b11e31849820debc98f.svg";
export { ForwardRef as ReactComponent };